/* istanbul ignore file */
export * from './SearchFeedback';
